<template>
    <div class="Scorecard">
        <h2>Scorecard Data <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetData()" class="olive-green-text pointer" /></h2>
        <form class="table-filters">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Start Date:</label>
                        <flat-pickr v-model="Filters.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>End Date:</label>
                        <flat-pickr v-model="Filters.EndDate" class="form-control" required :config="DateConfig"></flat-pickr>
                    </div>
                </div>
            </div>
        </form>
        <div class="row" v-if="WeeklyDatapointCount > 1">
            <div class="div-float" style="width:100%;">
                <table style="width:100%; margin-top: 15px;" class="table-striped table-hover">
                    <thead>
                        <tr class="center-cells">
                            <th class="headcol" style="border-style:none;"></th>
                            <th v-for="scoreWeek in WeeklyDateHeaders" v-bind:colspan="WeeklyDatapointCount">
                                {{ scoreWeek }}
                            </th>
                        </tr>
                        <tr class="center-cells">
                            <th class="headcol" style="border-style:none;"></th>
                            <th v-for="datapoint in WeeklyDatapointHeaders" style="white-space: nowrap;">
                                {{ datapoint }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="subProgram in Object.keys(ScorecardData['WeeklyDatapoints'])">
                            <td class="bold headcol" style="white-space: nowrap;">{{ subProgram }}</td>
                            <template v-for="scoreWeek in WeeklyDateHeaders">
                                <td class="center-text" v-for="datapoint in Object.keys(ScorecardData['WeeklyDatapoints'][subProgram][scoreWeek])">
                                    {{ ScorecardData['WeeklyDatapoints'][subProgram][scoreWeek][datapoint] }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <h4>Info:</h4>
                <p>Each week on the chart above represents data from Sunday-Saturday, with the Saturday date displayed.</p>
                <p><span class="bold">Foster Applicants: </span>The number of families who were in the application phase at least one day during the week.</p>
                <p><span class="bold">Families Approved: </span>The number of families who were approved during the week.</p>
                <p><span class="bold">Max Preferred Beds: </span>The sum of all MAX DESIRED BEDS for all active families at the end of the week.</p>
                <p><span class="bold">Filled Beds: </span>The program's census at the end of the week.</p>
                <p><span class="bold">Percent Filled: </span>Filled Beds divided by MAX DESIRED BEDS at the end of the week (expressed as a percentage).</p>
                <p><span class="bold">% of Clients Seen Twice (-30d): </span>Percent of clients who, in the prior 30 days to the week's end date, have at least 2 documented contact records.  Clients who have been in the program for less than 30 days are excluded.</p>
            </div>
        </div>
    </div>
</template>

<script>

    //import components
    import { EventBus } from '../../../services/event-bus.js';
    import apexchart from 'vue-apexcharts';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileExcel);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);

    export default {
        created() {
        },
        props: [],
        data: function () {
            return {
                Filters: {
                    StartDate: "",
                    EndDate: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: true
                },
                ScorecardData: {
                    WeeklyDatapoints: {
                        Loading: {
                            Loading: {
                                loading: 0
                            }
                        }
                    }
                }
            };
        },
        methods: {
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", "Dashboard/SubProgramScorecard/Scorecard/GetScorecardData", this.Filters, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.ScorecardData = response.data.data;
            },
            formatDate(value, fmt) {
                return (value == null)
                    ? ''
                    : moment(value, 'MM').format(fmt)
            }, 
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            apexchart,
            flatPickr
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptionsFiltered"]("Foster");
            },
            WeeklyDateHeaders: function () {
                if (this.ScorecardData['WeeklyDatapoints']) {
                    let firstSub = Object.keys(this.ScorecardData['WeeklyDatapoints'])[0];
                    return Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub]);
                } else {
                    return [];
                }
            },
            WeeklyDatapointHeaders: function () {
                if (this.ScorecardData['WeeklyDatapoints']) {
                    let firstSub = Object.keys(this.ScorecardData['WeeklyDatapoints'])[0];
                    let weekLength = Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub]).length;
                    let firstDate = Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub])[0];
                    let output = [];
                    for (var i = 0; i < weekLength; i++) {
                        Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub][firstDate]).forEach(function (item) {
                            output.push(item);
                        });
                    }
                    console.log("datapoint headers" + output);
                    return output;
                } else {
                    console.log("datapoint headers error");
                    return [];
                }
            },
            WeeklyDatapointCount: function () {
                if (this.ScorecardData['WeeklyDatapoints']) {
                    let firstSub = Object.keys(this.ScorecardData['WeeklyDatapoints'])[0];
                    let weekLength = Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub]).length;
                    let firstDate = Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub])[0];
                    
                    return Object.keys(this.ScorecardData['WeeklyDatapoints'][firstSub][firstDate]).length
                } else {
                    console.log("datapoint count error");
                    return 1;
                }
            }
        },
        mounted() {
            //this.Filters.StartDate = moment().add(-60, "days").format("YYYY-MM-DD");
            this.Filters.StartDate = moment().format("YYYY-MM-DD");
            this.Filters.EndDate = moment().format("YYYY-MM-DD");
            this.GetData();
        }
    }
</script>

<style scoped>
    .top-margin-md {
        margin-top: 20px;
    }

    .top-margin-sm {
        margin-top: 12px;
    }

    .bottom-margin-sm {
        margin-bottom: 12px;
    }

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }

    div.div-float {
        width: 800px;
        overflow-x: scroll;
        margin-left: 210px;
        overflow-y: visible;
        padding: 0;
    }

    .headcol {
        position: absolute;
        width: 200px;
        left: 30px;
        top: auto;
    }
</style>